import * as GC from '@grapecity/spread-sheets';
import { IDecayFactor } from '@models/decay/decay-factors';
import { IExportItem } from '@models/export/export-item';
import { round } from '@shared/numbers';
import { borders, colours, FONT_NAME, FONT_SIZE } from '@shared/spread/spread-settings';

export const addDecayFactorsToSheet = (
  sheet: GC.Spread.Sheets.Worksheet,
  rowIndex: number,
  startCol: number,
  exportItem: IExportItem,
  isApproved: boolean
): void => {
  try {
    const startRow = rowIndex;
    const rowSpan = 1;
    const colSpan = 2;
    let count = 0;

    let decayFactors: IDecayFactor[];
    if (isApproved) {
      decayFactors = exportItem.Decay.ApprovedDecayFactors;
      if (!decayFactors) {
        decayFactors = exportItem.Decay.ProposedDecayFactors;
      }
    } else {
      decayFactors = exportItem.Decay.ProposedDecayFactors;

      if (decayFactors.length === 0) {
        decayFactors = exportItem.Decay.ApprovedDecayFactors;
      }
    }

    decayFactors.forEach(decayFactor => {
      decayFactor.Factor = round(decayFactor.Factor, 4);
    });

    sheet.addSpan(startRow, startCol, rowSpan, colSpan);
    sheet.getCell(startRow, startCol).text('Decay Factors');

    // First column values
    count += decayFactors.length;
    sheet.setArray(
      startRow + 1,
      startCol,
      decayFactors.map(({ Observation }) => Observation)
    );

    // Second Column Values
    sheet.setArray(
      startRow + 1,
      startCol + 1,
      decayFactors.map(({ Factor }) => Factor)
    );

    // Styling
    const headerRange = sheet.getRange(startRow, startCol, rowSpan, colSpan);
    headerRange.backColor(colours.LIGHT_GREY);
    headerRange.setBorder(borders.BLACK_MEDIUM, { all: true });
    headerRange.font(`bold ${FONT_SIZE}pt ${FONT_NAME}`);
    headerRange.hAlign(GC.Spread.Sheets.HorizontalAlign.center);
    headerRange.vAlign(GC.Spread.Sheets.VerticalAlign.center);

    const contentRange = sheet.getRange(startRow + 1, startCol, decayFactors.length, colSpan);
    contentRange.backColor(colours.LIGHT_GREY);
    contentRange.setBorder(borders.GREY_NORMAl, { bottom: true, left: true, right: true, inside: true });
    contentRange.hAlign(GC.Spread.Sheets.HorizontalAlign.center);
    contentRange.vAlign(GC.Spread.Sheets.VerticalAlign.center);

    return;
  } catch (err) {
    console.error('Error Adding Decay Factors', err);
    return;
  }
};
